import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-ag-vehicle-trailer',
  templateUrl: './vehicle-trailer.component.html',
  styleUrls: ['./vehicle-trailer.component.css', '../../../quote.component.css']
})
export class AgVehicleTrailerComponent implements OnInit, OnChanges {
  @Input() vehicle;
  @Input() staticData;
  @Input() index;

  frmFields: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.buildForm();
    if (this.vehicle) {
      this.patchValues();
    }
    this.frmFields.valueChanges.subscribe(val => {
      if (this.vehicle) {
        Object.assign(this.vehicle, val);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.frmFields && this.vehicle) {
      this.patchValues();
    }
  }

  buildForm() {
    this.frmFields = this.fb.group({
      vin: [''],
      make: ['', Validators.required],
      model: ['', Validators.required],
      trailer_type: ['', Validators.required],
      value: ['', Validators.required],
    });
  }

  patchValues() {
    this.frmFields.patchValue({
      vin: this.vehicle.vin || '',
      make: this.vehicle.make || '',
      model: this.vehicle.model || '',
      trailer_type: this.vehicle.trailer_type || '',
      value: this.vehicle.value || '',
    }, { emitEvent: false });
  }

  get f() { return this.frmFields.controls; }
}
